<template>
  <div class="requisicao-lancamento ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="4">
          <label for="select-empresa-cor">Empresa</label>
          <multiselect
            id="selecao-empresa-cor"
            v-model="value_empresaf"
            required
            :options="empresasf"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="true"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="nomeempresarial"
            track-by="nomeempresarial"
            name="nomeempresarial"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="3">
          <label for="select-filial_cor">Filial</label>
          <multiselect
            id="selecao-filial-cor"
            v-model="value_filial"
            required
            :options="filiaisf"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadLaudo()"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <!--
              <b-col cols="2">
                <label for="select-garagem">Status</label>   
                <multiselect  v-model="value_status" required 
                  :options="statuss" 
                  :multiple="true" 
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a status" label="status" track-by="status" name="status"
                  :preselect-first="true">
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionado</span></template>
                </multiselect> 
              </b-col>
-->

        <b-col cols="4" class="mb-0">
          <label for="input-busca">Pesquisa no grid</label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Carro / Requisição / Solicitante "
          ></b-form-input>
        </b-col>

        <!--
              <b-col cols="1"  class="mt-4 ml-2">
                <b-button variant="warning" class="ml-5 mt-2" @click="novo(),loadNovoNrorequisicao(),loadTipos()"  v-b-modal.modal-multi-requisicao  >Novo</b-button>
              </b-col>
-->
      </b-row>

      <b-row>
        <b-col cols="6" class="mt-4">
          <b-card
            class="ml-2"
            style="width: 33rem"
            border-variant="primary"
            header="QUANTIDADE DE LAUDOS"
            header-bg-variant="primary"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{ itemsFiltered.length }}
              </h2>
            </b-card-text>
          </b-card>
        </b-col>

        <b-col cols="6" class="mt-3">
          <b-card
            class="mr-2"
            style="width: 33rem"
            border-variant="primary"
            header="VALOR R$"
            header-bg-variant="success"
            header-text-variant="white"
            align="center"
          >
            <b-card-text>
              <h2>
                {{
                  itemsFiltered
                    .map((sal) => sal.carro)
                    .filter(
                      (valor, indice, self) => self.indexOf(valor) === indice
                    ).length
                }}
              </h2>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="tbldefeitos"
      small
      hover
      striped
      sticky-header="660px"
      :items="itemsFiltered"
      :fields="requisicaoCabecalho"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="
            editrequisicaoCabecalho(data.item),
              loadLaudoItem(),
              loadVeiculo(),
              loadResponsavel()
          "
          v-b-modal.modal-multi-requisicao
          title="Acessar laudo"
          size="sm"
          variant="success"
          class="mr-2"
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
    <div>
      <b-modal
        id="modal-multi-requisicao"
        hide-footer
        size="xl"
        centered
        title="Cadastro de laudo "
        @close="novo()"
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <!-- EMPRESA FILIAL -->
          <b-row id="defeito-selecao">
            <b-col cols="4">
              <label for="input-garagem">Empresa</label>
              <!-- {{requisicao.id_filial}} -->
              <div>
                <b-form-select
                  id="garagem"
                  v-model="requisicao.empresa_id"
                  required
                  :options="empresas"
                  @change="loadFiliaisCad()"
                  class="mb-4"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="4">
              <label for="input-garagem">Filial</label>
              <!-- {{requisicao.id_filial}} -->
              <div>
                <b-form-select
                  id="garagem"
                  v-model="requisicao.filial_id"
                  required
                  :options="filiais"
                  @change="loadLinhas()"
                  class="mb-3"
                  text-field="filial"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Data de abertura</label>
              <b-input-group-text>{{
                requisicao.dt_cadastro
                  ? moment(requisicao.dt_cadastro)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <!--

            <b-col cols="2">
                <label for="input-live">Data de fechamento</label>     
                <b-input-group-text >{{ requisicao.dt_encerramento ? moment(requisicao.dt_encerramento).format('DD/MM/YYYY HH:mm').replace('Data inválida','-')  : '-'  }}</b-input-group-text>
            </b-col> 

-->

            <b-col cols="2">
              <label for="input-live">Nº do laudo</label>
              <b-input-group-text id="nrolaudo">{{
                nrorequisicao.length > 0 ? nrorequisicao : requisicao.laudo_id
              }}</b-input-group-text>
            </b-col>
          </b-row>

          <!-- seleção -->
          <b-row id="defeito-selecao">
            <b-col cols="2" class="mb-3">
              <label for="input-live">Carro</label>
              <b-form-input
                v-model="requisicao.carro"
                @keyup.enter="loadVeiculo()"
                required="required"
                placeholder="Nro carro"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Placa </label>
              <b-input-group-text>{{
                veiculos ? veiculos.map((at) => at.placa).join(", ") : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Linha</label>
              <b-form-input
                v-model="requisicao.linha"
                required
                placeholder="Order de serviço"
              ></b-form-input>
            </b-col>

            <!--Almoxarife -->

            <!--Almoxarife -->
            <b-col cols="1" class="mt-2">
              <b-img
                class="mb-2"
                v-model="requisicao.responsavel_foto"
                :src="
                  requisicao.responsavel_foto
                    ? requisicao.responsavel_foto
                    : 'https://ml18cliente.s3.sa-east-1.amazonaws.com/sambaiba/sem-foto.jpg'
                "
                rounded
                alt="-"
                style="width: 66px; height: 66px"
              ></b-img>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Responsável</label>
              <b-form-input
                v-model="requisicao.responsavel_registro"
                @keyup.enter="loadResponsavel()"
                required
                placeholder="RE"
              ></b-form-input>
            </b-col>

            <b-col cols="3">
              <label for="input-live">Função</label>
              <b-input-group-text>{{
                requisicao.responsavel_registro
                  ? requisicao.responsavel_funcao
                  : "-"
              }}</b-input-group-text>
              <!--   almoxarifes.map(at => at.funcao).join(', ')   -->
            </b-col>

            <b-col cols="12" class="mb-2">
              <label for="input-live">Observações gerais</label>
              <b-form-input
                v-model="requisicao.observacao"
                readonly
                required="required"
                placeholder="Observações"
              ></b-form-input>
            </b-col>
          </b-row>

          <!--
            <b-row id="id-informado" class="pt-1 pb-1">

    
              <b-col cols="2" >
                <label for="input-live">Solicitante</label> 
                <b-form-input v-model="laudoitem.re_requisitante" @keyup.enter="loadExecutante()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="4">
                <label for="input-live">Função  </label>                 
                <b-input-group-text >{{ solicitantes ? solicitantes['funcao'] : '-' }}</b-input-group-text>
              </b-col> 
              

    
              <b-col cols="2" >
                <label for="input-live">Lider</label> 
                <b-form-input v-model="laudoitem.re_lider" @keyup.enter="loadLider()" required placeholder="RE"></b-form-input>              
              </b-col> 

              <b-col cols="4">
                <label for="input-live">Função  </label>                 
                <b-input-group-text >{{ lideres.funcao ? lideres['funcao'] : '-' }}</b-input-group-text>
              </b-col> 
              

     


            </b-row>
-->

          <b-row id="id-itemsolicitado" class="pt-1 pb-1">
            <!--material               -->

            <b-col cols="2">
              <label for="input-live">Nº Fogo</label>
              <b-form-input
                v-model="laudoitem.nrofogo"
                required
                placeholder="Código"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Vida</label>
              <b-form-input
                v-model="laudoitem.vida"
                required
                placeholder="Código"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Fabricante</label>
              <b-input-group-text id="material_descricao">{{
                laudoitem.fabricante ? laudoitem.fabricante : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Medida</label>
              <b-input-group-text id="material_descricao">{{
                laudoitem.medida ? laudoitem.medida : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Borracha</label>
              <b-input-group-text id="material_descricao">{{
                laudoitem.borracha ? laudoitem.borracha : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Carcaça</label>
              <b-input-group-text id="material_descricao">{{
                laudoitem.carcaca ? laudoitem.carcaca : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="6" class="mb-0">
              <label for="input-live">Observações do solicitante</label>
              <b-form-input
                v-model="laudoitem.observacao_item"
                readonly
                required="required"
                placeholder="Observações"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <div>
                <label for="datepicker-placeholder">Data colocação</label>
                <b-form-datepicker
                  id="dt_sol_inicial"
                  required
                  v-model="laudoitem.dt_colocacao"
                  placeholder="colocação "
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="2">
              <div>
                <label for="datepicker-placeholder">Data retirada</label>
                <b-form-datepicker
                  id="dt_sol_inicial"
                  required
                  v-model="laudoitem.dt_retirada"
                  placeholder="retirada "
                  locale="pt-BR"
                  date-format-options="DD/MM/YYYY"
                ></b-form-datepicker>
              </div>
            </b-col>

            <b-col cols="2">
              <label for="input-live">R$ Valor</label>
              <b-form-input
                v-model="laudoitem.valor"
                required
                placeholder="a cobrar"
              ></b-form-input>
            </b-col>
          </b-row>

          <!-- fechamento -->
          <b-row id="id-encerramento" cols="10" class="mt-2">
            <b-col cols="2">
              <label for="input-live">Data Abertura</label>
              <b-input-group-text>{{
                laudoitem.dt_cadastro
                  ? moment(laudoitem.dt_cadastro)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">Data entrega</label>
              <b-input-group-text>{{
                laudoitem.dt_entrega
                  ? moment(laudoitem.dt_entrega)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2">
              <label for="input-live">ERP Nro Ficha</label>
              <b-form-input
                v-model="requisicao.os_id"
                readonly
                placeholder="A18562022"
              ></b-form-input>
            </b-col>

            <b-col cols="2">
              <label for="input-live">ERP Data importação</label>
              <b-input-group-text>{{
                requisicao.dt_jb_acesso
                  ? moment(requisicao.dt_jb_acesso)
                      .format("DD/MM/YYYY HH:mm")
                      .replace("Data inválida", "-")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="2" class="mt-4">
              <b-button
                size="sm"
                id="btn-gerarpdf2"
                variant="warning"
                class="mr-2 mt-2"
                @click="gerarPDFLesser()"
              >
                Gerar Pdf
              </b-button>
            </b-col>

            <b-col cols="1" class="mt-2 mb-2">
              <b-button
                class="mt-4"
                variant="success"
                @click="encerrarCabecalho()"
              >
                <b-spinner v-if="carregando" small style="margin-bottom: 3px">
                </b-spinner>
                Encerrar
              </b-button>
            </b-col>

            <b-col cols="1" class="mt-2 mb-2">
              <b-button
                class="mt-4"
                variant="danger"
                :disabled="carregando"
                @click="reset()"
              >
                <b-spinner v-if="carregando" small style="margin-bottom: 3px">
                </b-spinner>
                Gravar
              </b-button>
            </b-col>
          </b-row>

          <!-- defeitos da requisicao -->
          <b-table
            id="tbrequisicaodefeitos"
            small
            hover
            striped
            sticky-header="520px"
            :items="laudoitens"
            :fields="requisicaoCorpo"
          >
            <template slot="cell(actions)" slot-scope="data">
              <b-button
                @click="editrequisicaoCorpo(data.item)"
                title="Editar item do laudo"
                size="sm"
                variant="success"
                class="mr-2"
              >
                <i class="fa fa-exclamation-circle"></i>
              </b-button>

              <b-button
                @click="editrequisicaoCorpo(data.item), loadLaudoItemFoto()"
                title="Exibir fotos"
                size="sm"
                variant="primary"
                class="mr-2"
                v-b-modal.modal-LaudoFotos
              >
                <i class="fa fa-photo"></i>
              </b-button>
            </template>
          </b-table>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->

    <div>
      <b-modal
        id="modal-LaudoFotos"
        hide-footer
        size="lg"
        :title="`Laudo Nº.: ${
          laudoitem.laudo_id == null ? '' : laudoitem.laudo_id
        }`"
        no-close-on-backdrop
      >
        <div class="d-flex justify-content-center" style="height: 80vh">
          <b-carousel
            id="carouselFoto"
            class="carouselFoto"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ababab"
            style="text-shadow: 1px 1px 2px #333"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <b-carousel-slide
              v-for="(photo, index) in photos"
              :key="index"
              :img-src="photo.foto_thumbnail"
            ></b-carousel-slide>
          </b-carousel>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import VueTheMask from "vue-the-mask";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ManutencaoRfiLancamento",

  /*
    computed: mapState(['user']),   
    */

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let valorefu = [];
      valorefu = this.laudos.filter((item) => {
        const carro = item.carro || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const requisitante = item.requisitante || "";
        const requisicao = item.id || "";
        //const ordem = item.os_id || '';
        return (
          carro.indexOf(this.search) > -1 ||
          requisitante.indexOf(this.search) > -1 ||
          requisicao.indexOf(this.search) > -1
          //|| ordem.indexOf(this.search) >-1
        );
      });
      return valorefu;
    },

    itemsFilteredQtd() {
      let valorefu = [];
      valorefu = this.ResumorequisicaoCorpo.filter((item) => {
        const carro = item.carro || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const requisitante = item.re_requisitante || "";
        const requisicao = item.requisicao || "";
        //const ordem = item.os_id || '';
        return (
          carro.indexOf(this.search) > -1 ||
          requisitante.indexOf(this.search) > -1 ||
          requisicao.indexOf(this.search) > -1
          //|| ordem.indexOf(this.search) >-1
        );
      });
      return valorefu;
    },
  },

  data: function () {
    return {
      laudos: [],
      laudoitens: [],
      photos: [],
      laudoitem: {},
      ResumorequisicaoCorpo: [],

      executante: {}, //   18/02/2024
      executantes: [],
      lider: {},
      lideres: [],
      almoxarifes: [],
      almoxarife: {},
      materiais: [],
      empresas: [],
      filiais: [],
      empresasf: [],
      empresaf: {},
      filiaisf: [],
      filialf: {},
      veiculos: [],
      operador: [],
      socorrista_carro: [],
      trocado_carro: [],
      socorristas: [],
      requisicaos: [],
      requisicao: {},
      viacep: [],

      value_empresaf: [],

      defeitos: [],
      defeito: {},

      gruposi: [],
      subgruposi: [],
      defeitosi: [],

      gruposd: [],
      subgruposd: [],
      defeitosd: [],

      mode: "save",
      carregando: false,
      atualizando: false,

      grupo: {},
      grupos: [],
      subgrupo: {},
      subgrupos: [],
      defeito: {},
      defeitos: [],

      // gruposd:[],
      gruposd: {},
      subgrupod: {},
      subgruposd: [],
      defeitod: {},

      solicitante: {},
      solicitantes: [],

      socorrista: {},
      linhas: [],

      nrorequisicao: [],

      requisicaoEditCorpo: [],

      statuss: [],
      situacaojb: [],

      value_carro: "",
      value_carro_socorrista: "",
      value_carro_trocado: "",
      value_cep: "",
      value_solicitante: "",
      value_executante: "",
      value_socorrista: "",
      value_status: [],
      value_statusjb: [],
      value_tipo: [],
      value_lider: "",
      value_almoxarife: "",
      value_filial: [],

      //garagem:{},
      tipos: [],
      search: "",

      lin: {},

      value_garagem: [], // [] lista

      value_observacoes: "",

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      requisicaoCabecalho: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "filial_id", label: "Filial", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Abertura",
          sortable: true,
          formatter: (value, key, laudos) => {
            return moment(laudos.dt_cadastro)
              .format("DD/MM/YYYY HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "laudo_id", label: "Nro Laudo", sortable: true },
        { key: "responsavel_registro", label: "Responsável", sortable: true },
        { key: "linha", label: "Linha", sortable: true },
        { key: "observacao", label: "Observações", sortable: true },
        { key: "actions", label: "Ações" },
      ],

      //////// defeitos da requisicao
      requisicaoCorpo: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "filial_id", label: "Filial", sortable: true },
        { key: "nrofogo", label: "Nº fogo", sortable: true },
        { key: "vida", label: "Vida", sortable: true },
        { key: "medida", label: "Medida", sortable: true },
        { key: "fabricante", label: "Fabricante", sortable: true },
        {
          key: "carcaca",
          label: "Carcaça",
          sortable: true,
          tdClass: "col-descricao",
        },
        { key: "observacao_item", label: "Observação do item", sortable: true },
        /*
                { key: 'dt_colocacao', label: 'Data colocação', sortable: true, formatter: (value, key, requisicaoEditCorpo) => {
                    return moment(laudoitem.dt_colocacao).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                
                { key: 'dt_retirada', label: 'Data Retirada', sortable: true, formatter: (value, key, requisicaoEditCorpo) => {
                    return moment(laudoitem.dt_retirada).format('DD/MM/YYYY').replace('Data inválida','-') ; }  },                
                    */
        { key: "actions", label: "Ações" },
      ],
    };
  },

  filters: {
    dataFormatada(dt) {
      return dt.substring(0, 4);
    },
  },

  components: {
    Multiselect,
    VueTheMask,
  },

  methods: {
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },

    limparFiltro() {
      this.search = "";
    },

    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliais() {
      let params = {
        psg: this.user.psg,
        id_empresa: `${this.user.id_empresa}`,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiaisf = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    ////////////////////////////////////////////////////////////////////  metodos requisição 15/02/2024
    loadLaudo() {
      let params = {
        empresa_id: this.user.id_empresa
          ? `${[this.user.id_empresa]}`
          : `${[this.value_empresaf.map((e) => e.id_empresa)]}`,
        filial_id: this.this.value_filial.map((f) => f.id_filial_erp)
          ? `${this.value_filial.map((f) => f.id_filial_erp)}`
          : `${[this.user.id_filial_erp]}`,
        filtro: "consulta",
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/laudo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.laudos = res.data;
          //this.loadLaudoItem()
        })
        .catch(showError);
    },

    loadLaudoItem() {
      let params = {
        psg: this.user.psg,
        empresa_id: this.user.id_empresa
          ? `${[this.user.id_empresa]}`
          : `${[this.value_empresaf.map((e) => e.id_empresa)]}`,
        filial_id: this.this.value_filial.map((f) => f.id_filial_erp)
          ? `${this.value_filial.map((f) => f.id_filial_erp)}`
          : `${[this.user.id_filial_erp]}`,
        laudo_id: `${[this.requisicao.laudo_id]}`,
        filtro: "consultaitem",
      };
      const url = `${baseApiUrl}/pneu/laudo/item`;
      axios
        .post(url, { params })
        .then((res) => {
          this.laudoitens = res.data;
        })
        .catch(showError);
    },

    loadLaudoItemFoto() {
      let corpo = {
        psg: this.user.psg,
        laudo_id: `${[this.requisicao.laudo_id]}`, //nrofogo_id
        nrofogo_id: `${[this.laudoitem.nrofogo_id]}`, //nrofogo_id
        filtro: "fotolaudo",
      };
      const url = `${baseApiUrl}/pneu/laudo/item`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.photos = res.data;
        })
        .catch(showError);
    },

    async gerarPDFLesser() {
      try {
        const doc = new jsPDF();

        const startX = 14;
        const startY = 10;

        const fontSize = 8; // Defina o tamanho da fonte desejado

        doc.setFontSize(fontSize); // Define o tamanho da fonte para todos os textos seguintes

        doc.text("SAMBAIBA TRANSPORTES URBANOS LTDA", startX, startY + 3, {
          align: "left",
        });
        doc.text(
          "Registro: " +
            this.requisicao.responsavel_registro +
            " - " +
            this.almoxarifes["nome"] +
            "-" +
            this.almoxarifes["funcao"],
          startX,
          startY + 8,
          { align: "left" }
        );
        doc.text("Laudo: " + this.requisicao.laudo_id, startX, startY + 12, {
          align: "left",
        });
        doc.text("Linha: " + this.requisicao.linha, startX, startY + 16, {
          align: "left",
        });
        doc.text(
          "Data gravação: " +
            moment(this.requisicao.dt_cadastro).format("DD/MM/YYYY"),
          startX,
          startY + 20,
          { align: "left" }
        );

        const pageCount = doc.internal.getNumberOfPages();
        const footerFontSize = 6; // Defina o tamanho da fonte para o rodapé

        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const footerX = 10;
          const footerY = doc.internal.pageSize.height - 10;
          const currentDate = moment().format("DD/MM/YYYY - HH:mm");
          const pageNumber = "Página " + i + " de " + pageCount;
          const footerText = "Data: " + currentDate + " | " + pageNumber;

          doc.setFontSize(footerFontSize); // Define o tamanho da fonte
          doc.text(footerText, footerX, footerY);

          // Verifica se estamos na última página
          if (i === pageCount) {
            const assinaturaY = footerY - 10; // Ajuste conforme necessário
            doc.text(
              "____________________________________________________________________",
              footerX,
              assinaturaY - 5
            );
            doc.text(
              "Assinatura: " +
                this.almoxarifes["nome"] +
                "-" +
                this.almoxarifes["funcao"],
              footerX,
              assinaturaY
            );
          }
        }

        doc.save(
          "ficha_ponto_" +
            this.operador.registro +
            "_ periodo_" +
            moment(this.data_inicial).format("DD-MM-YYYY") +
            "_ate_" +
            moment(this.data_final).format("DD-MM-YYYY") +
            ".pdf"
        );
      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      }
    },
    loadrequisicaoCorpo() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        filial_id: `${this.value_filial.map((f) => f.id_filial_erp)}`,
      };
      const url = `${baseApiUrl}/estoque/requisicao/consulta/corpo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.ResumorequisicaoCorpo = res.data;
        })
        .catch(showError);
    },

    editrequisicaoCorpo(laudoitem) {
      /// 18/02/2024
      this.laudoitem = { ...laudoitem };
      this.loadResponsavel();
      this.loadVeiculo();
    },

    loadrequisicaoAnalitica() {
      /// 18/02/2024
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${[this.requisicao.empresa_id]}`,
        requisicao_id: this.requisicao.id
          ? this.requisicao.id
          : `${[this.nrorequisicao]}`,
      };
      const url = `${baseApiUrl}/estoque/requisicao/corretiva`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.requisicaoEditCorpo = res.data;
        })
        .catch(showError);
    },

    loadVeiculo() {
      let corpo = {
        psg: this.user.psg,
        id_empresa: `${this.requisicao.empresa_id}`,
        prefixo: `${this.requisicao.carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.veiculos = res.data;
        })
        .catch(showError);
    },

    async loadExecutante() {
      let corpo = {
        psg: this.user.psg,
        registro: `${this.laudoitem.re_requisitante}`,
        id_empresa: `${this.laudoitem.empresa_id}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.solicitantes = res.data;
      });
    },

    async loadLider() {
      let corpo = {
        psg: this.user.psg,
        registro: `${this.laudoitem.re_lider}`,
        id_empresa: `${this.laudoitem.empresa_id}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.lideres = res.data;
      });
    },

    async loadResponsavel() {
      let corpo = {
        psg: this.user.psg,
        registro: `${this.value_almoxarife}`,
        id_empresa:
          this.laudoitem.empresa_id > 0
            ? `${this.laudoitem.empresa_id}`
            : `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.almoxarifes = res.data;
      });
    },

    /////////////////////////////////////////////////////////
    async postCorpo() {
      let corpo = {
        psg: this.user.psg,
        id: `${this.laudoitem.item}`,
        empresa_id: `${this.requisicao.empresa_id}`,
        filial_id: `${this.requisicao.filial_id}`,
        laudo_id:
          this.requisicao.id > 0 ? this.requisicao.id : `${this.nrorequisicao}`,
        laudo_id: `${this.laudoitem.laudo_id}`,
        //"carro_id": `${veiculos.map(at => at.id_veiculo).join(', ')}`,
        operacao_id: 2, // consumo
        nrofogo_id: `${this.materiais["id"]}`,
        tipo_id: 2, //= corretiva
        status_id: this.qtd_atendida != null ? 3 : null, //= corretiva
        qtd_solicitado: `${[this.laudoitem.qtd_solicitado]}`,
        qtd_atendida: `${[this.laudoitem.qtd_atendida]}`,
        observacao: `${[this.laudoitem.observacao]}`,
        almoxarife_id: `${this.almoxarifes["id_funcionario"]}`,
        requisitante_id: `${this.solicitantes["id_funcionario"]}`,
        lider_id: `${this.lideres["id_funcionario"]}`,
        venda_perdida: `${this.laudoitem.venda_perdida}`,
        funcionario_cad: `${this.user.id_funcionario}`,
        baixa: "web",
      };
      const url = `${baseApiUrl}/estoque/requisicao/corpo`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.limparCorpo()
          this.$toasted.global.defaultSuccess();
          this.loadrequisicaoAnalitica();
          // this.loadrequisicaoMonitoramento()                                 carregamento dentro da requisicao selecionada
        })
        .catch(showError);
    },

    /////////atualizar encerramento da requisição 18/02/2024
    async encerrarCabecalho() {
      let corpo = {
        psg: this.user.psg,
        id:
          this.nrorequisicao.length > 0
            ? this.nrorequisicao
            : `${this.requisicao.id}`,
        dt_cadastro: `${this.laudoitem.dt_cadastro}`,
        id_funcionario_encerrou: `${this.user.id_funcionario}`,
        lider_id: `${this.lideres["id_funcionario"]}`,
        requisitante_id: `${this.solicitantes["id_funcionario"]}`,
        status_id: 3,
      };
      const url = `${baseApiUrl}/estoque/requisicao/cadcabecalho`;
      axios
        .post(url, corpo)
        .then(() => {
          this.loadLaudo(), // 19/02/2024
            //this.loadrequisicaoCorpo()
            this.loadrequisicaoAnalitica();
          this.$toasted.global.defaultSuccess();
          this.limparCorpo();
        })
        .catch(showError);
    },

    loadEmpresaCad() {
      let corpo = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadFiliaisCad() {
      let corpo = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.filiais = res.data.map((fil) => {
            return { ...fil, value: fil.id_filial_erp, filial: fil.filial }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadTipos() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.user.id_empresa}`,
      };
      const url = `${baseApiUrl}/manutencao/requisicao/tipo`;
      axios.post(url, corpo).then((res) => {
        this.tipos = res.data.map((tp) => {
          return { ...tp, value: tp.id, tipo: tp.tipo, sos: tp.sos };
        });
      });
    },

    loadLinhas() {
      let corpo = {
        psg: this.user.psg,
        id_empresa: `${this.requisicao.empresa_id}`,
        id_filial: `${this.requisicao.filial_id}`,
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.linhas = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },
    //              .then(res => { this.operador = res.data })

    loadVeiculoSocorrista() {
      let corpo = {
        psg: this.user.psg,
        id_empresa: `${this.requisicao.empresa_id}`,
        carro: `${this.requisicao.carro_socorrista}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.socorrista_carro = res.data;
        })
        .catch(showError);
    },

    loadVeiculoTrocado() {
      let corpo = {
        psg: this.user.psg,
        id_empresa: `${this.requisicao.empresa_id}`,
        carro: `${this.requisicao.carro_trocado}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.trocado_carro = res.data;
        })
        .catch(showError);
    },

    loadCep() {
      axios
        .get("https://viacep.com.br/ws/" + this.requisicao.cep + "/json/")
        .then((res) => {
          this.viacep = res.data;
        });
    },

    async loadOperador() {
      let corpo = {
        psg: this.user.psg,
        registro: `${this.requisicao.operador}`,
        id_empresa: `${this.requisicao.empresa_id}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.operador = res.data;
      });
    },

    async loadSocorrista() {
      let corpo = {
        psg: this.user.psg,
        registro: `${this.requisicao.socorrista}`,
        id_empresa: `${this.requisicao.empresa_id}`,
      };
      const url = `${baseApiUrl}/glo/escala/consulta`;
      axios.post(url, corpo).then((res) => {
        this.socorristas = res.data;
      });
    },

    loadrequisicaoStatus() {
      let params = {
        psg: this.user.psg,
        registro: `${this.requisicao.socorrista}`,
        id_empresa: `${this.requisicao.empresa_id}`,
      };

      const url = `${baseApiUrl}/manutencao/requisicao/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((st) => {
          return { ...st, value: st.id_status, status: st.status };
        });
      });
    },

    loadrequisicaoStatusJb() {
      let params = {
        psg: this.user.psg,
        registro: `${this.requisicao.socorrista}`,
        id_empresa: `${this.requisicao.empresa_id}`,
      };
      const url = `${baseApiUrl}/manutencao/requisicao/jbstatus`;
      axios.get(url, { params }).then((res) => {
        this.situacaojb = res.data.map((jst) => {
          return { ...jst, value: jst.id_jb_status, status: jst.jbstatus };
        });
      });
    },

    loadNovoNrorequisicao() {
      const url = `${baseApiUrl}/manutencao/requisicao/nro`;
      axios.get(url).then((res) => {
        this.nrorequisicao = res.data.rows[0].nextval;
      });
    },

    async postCabecalho() {
      let corpo = {
        // {nrorequisicao.length > 0 ? nrorequisicao : requisicao.id
        psg: this.user.psg,
        id:
          this.nrorequisicao.length > 0
            ? this.nrorequisicao
            : `${this.requisicao.id}`,
        id_funcionario_encerrou: `${this.user.id_funcionario}`,
        status_id: 3,
      };
      const url = `${baseApiUrl}/manutencao/requisicao/inscabecalho`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.postCorpo()
        })
        .catch(showError);
    },

    ///////////////////////////////// 31/12/2022 as 20:17h
    editrequisicaoCabecalho(requisicao) {
      this.requisicao = { ...requisicao };
      this.editrequisicaoCorpo();
      this.loadFiliaisCad();
    },

    loadrequisicaoMonitoramento() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${[this.user.id_empresa]}`,
        id_empresa: `${[this.value_empresaf.map((e) => e.id_empresa)]}`,
        filial_id: `${[this.filiaisf.map((f) => f.id_filial_erp)]}`,
        status_id: `${[this.value_status.map((s) => s.id)]}`,
        tipo_id: `${[this.value_tipo.map((t) => t.id)]}`,
      };
      const url = `${baseApiUrl}/manutencao/requisicao/monitoramento`;
      axios
        .post(url, corpo)
        .then((res) => {
          this.requisicaos = res.data;
        })
        .catch(showError);
    },

    reset() {
      this.postCorpo();
    },

    limparCorpo() {
      this.defeito = [];
      this.executante = [];
      this.lider = [];
      this.value_executante = "";
      this.value_lider = "";
      ///this.nrorequisicao=[]  // precisa limpar somente ao fechar ou quando cria-se uma nova ficha
    },

    novo() {
      this.requisicao = {};
      this.defeito = {};
      this.requisicaoEditCorpo = {};
      //this.loadNovoNrorequisicao()
      //this.loadrequisicaoMonitoramento()
    },
  },

  mounted() {
    this.loadEmpresaCad();
    this.loadEmpresas();
    this.loadFiliais();
    this.loadLaudo(); //               // 30/07/2024
    //this.loadLaudoItem() //           // 30/07/2024

    //this.loadrequisicaoAnalitica()
    //this.loadrequisicaoStatus()
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#placa {
  font-size: 0.7em;
}

#modal-multi-requisicao___BV_modal_content_ {
  background: rgb(227, 236, 227);
  /* border: 1px solid rgb(58, 20, 196) ; */
  border-radius: 8px;
  margin-bottom: 4px;
}

#defeito-selecao {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-sos {
  background: rgb(199, 222, 218);
  border: 1px solid red;
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-informado {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(58, 20, 196);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-itemsolicitado {
  background: rgb(234, 239, 181);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#id-encerramento {
  background: rgb(199, 222, 218);
  border: 1px solid rgb(12, 90, 2);
  border-radius: 8px;
  margin-bottom: 4px;
}

#requisicao-nro {
  color: rgb(240, 8, 8);
  font-size: 18px;
  text-align: center;
}

#nrolaudo {
  color: rgb(240, 8, 8);
  font-size: 22px;
  text-align: center;
}

#garagem {
  font-size: 12px;
  text-align: center;
}

.col-descricao {
  width: 300px; /* Largura desejada para a coluna 'Requisição' */
}
</style>